import React from "react";
import { useHistory } from "react-router-dom";
const PageNotFound = () => {
  const history = useHistory();

  return (
    <div>
      <main className="d-flex d-flex align-items-center w-100 h-100">
        <div className="container d-flex align-items-center">
          <div className="row vh-100">
            <div className="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                <div className="text-center">
                  <h1>Access Denied</h1>
                  <p className="mb-3">You do not have permission to access this page or resource.</p>
                  <p>If you believe this is a mistake, please contact the administrator or support team.</p>
                  <button className="btn btn-primary btn-lg" onClick={() => history.goBack()}>
                    Go Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PageNotFound;
